import { IStatement } from '../model/schemas';

export const statements: IStatement[] = [
  {
    name: 'Account statement',
    description: 'For any period',
    lastUploadTime: '',
  },
  {
    name: 'Proof of account',
    description: 'With or without banking details',
    lastUploadTime: '',
  },
];

export const regularStatements: IStatement[] = [
  {
    name: 'Tax doc 2025',
    description: 'EUR account · Every monday',
    lastUploadTime: new Date('10.08.2024').toDateString(),
  },
];
